import { parseDate } from './dates';

export const isNumber = (value: string) => !isNaN(Number(value));

export const isValidDate = (value: string) => {
  //if (/^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/.test(value)) {
  if (parseDate(value) instanceof Date && !isNaN(parseDate(value).getTime())) {
    return true;
  }
  //}
  return false;
};

export const isValidZipcode = (value: string, errorMessage: string) =>
  value ? /^[1-9][0-9]{3}\s*[a-z]{2}$/i.test(value) || errorMessage : true;

export const isValidDutchPhoneNumber = (value: string, errorMessage: string) => {
  // Remove all non-numeric characters (like spaces, hyphens, etc.)
  const cleanNumber = value.toString().replace(/\D/g, '');

  // Validate Dutch landline numbers (3-digit area code + 7 digits)
  const landlinePattern =
    /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;

  // Validate Dutch mobile numbers (2-digit carrier code + 8 digits)
  const mobilePattern = /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
  // Check if the cleaned number matches either pattern
  return landlinePattern.test(cleanNumber) || mobilePattern.test(cleanNumber) || errorMessage;
};

export const isValidEmail = (value: string, errorMessage?: string) => {
  // Email validation regex
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(value) || errorMessage;
};

export const utilsValidationsDateMustBeAfter = (
  value: string,
  errorMessage: string,
  after?: Date
) => {
  const date = parseDate(value);
  after = after || new Date();
  after.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison
  return date > after || errorMessage;
};
